export default __webpack_public_path__ + "static/media/full_logo.14c31f40.png";